import React from 'react';
import { useSelector } from 'react-redux';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { getLink } from 'shared/helper/link-helper';
var OrderReeditLink = function OrderReeditLink(_ref) {
  var order = _ref.order;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var inactiveServicesLink = "/support/index/submission/".concat(order.externalId, "/type/inactive-service");
  var linkAvailable = order.downloadAvailable && (order.touchUpAvailable || order.reeditAvailable);
  var scientificReworkLink = useSelector(function (_ref2) {
    var application = _ref2.application;
    return getLink({
      application: application,
      linkName: 'scientificReworkLink'
    });
  });
  if (!linkAvailable) {
    return order.scientificReworkEligible ? /*#__PURE__*/React.createElement("a", {
      "aria-label": t('request-additional-work'),
      className: "action-link d-block",
      href: scientificReworkLink,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement(T, {
      source: "request-additional-work"
    })) : null;
  }
  var reeditLinkTitle = order.touchUpAvailable ? 'Submit for a Free Re-edit' : 'Submit for re-edit';
  var reworkEnabledLink = "/api/order-form/rework/".concat(order.externalId);
  return order.containsActiveService ? /*#__PURE__*/React.createElement(Link, {
    to: order.touchUpAvailable ? reworkEnabledLink : "/researcher/index/re-edit/".concat(order.externalId),
    target: "_blank",
    rel: "noopener noreferrer",
    className: "action-link text-uppercase d-block"
  }, /*#__PURE__*/React.createElement(T, {
    source: reeditLinkTitle
  })) : /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Contact support for re-edits'),
    className: "action-link text-uppercase d-block",
    href: inactiveServicesLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Contact support for re-edits"
  }));
};
export default OrderReeditLink;